/**
 * @file Cookie
 * @author ss
 */

const Cookie = {
  get(key) {
    const arr = document.cookie.match(new RegExp(`(^| )${key}=([^;]*)(;|$)`));
    if (arr != null) return unescape(arr[2]);
    return null;
  },
  set(key, value) {
    if (!this.get(key)) {
      document.cookie = `${key}=${value}`;
    }
  },
};

export default Cookie;



// WEBPACK FOOTER //
// ./src/utils/Cookie/index.js